import React from 'react'
import './Address.css'

function Address() {
  return (
   
    <div className='form-box'>
        <form className='form-ele'>
            <lable className='la'>Street</lable>
            <input className='input' type="text"  placeholder='Street'/>

            <label  className='la'>State</label>
            <input  className='input' type="text" placeholder='State'/>

            <label  className='la'>City</label>
            <input className='input' type="text"  placeholder='City'/>

            <label  className='la'>Zip</label>
            <input className='input' type="number"  placeholder='Zip'/>

            <label  className='la'>Phone</label>
            <input className='input'  type="number"  placeholder='Phone'/>
            <button className='order-ele'>Order-Now</button>
        </form>
    </div>


  )
}

export default Address
